import { useEffect, useState } from 'react';
import { marketplaceApi, type Profile } from '../api/marketplace';
import { getWebApp, isInsideTelegram, openTelegram } from '../lib/telegram';
import { StarIcon } from '../features/tabs/icons';
import { ErrorState, Loader } from '../components/States';
import './ProfilePage.css';

// Ссылки задаются на сборке: у магазина и у его форка поддержка разная, а
// зашитый в код @username однажды уже уедет в прод чужим.
const SUPPORT_URL = import.meta.env.VITE_SUPPORT_URL || 'https://t.me/AuroSupport1';
const TERMS_URL = import.meta.env.VITE_TERMS_URL;

export function ProfilePage() {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    marketplaceApi
      .me()
      .then((data) => !cancelled && setProfile(data))
      .catch((cause: unknown) => !cancelled && setError(cause instanceof Error ? cause.message : 'Ошибка загрузки'));

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) return <ErrorState message={error} />;
  if (!profile) return <Loader />;

  const webApp = getWebApp();

  return (
    <div className="profile">
      <div className="profile__card">
        {profile.avatarUrl ? (
          <img className="profile__avatar" src={profile.avatarUrl} alt="" />
        ) : (
          <div className="profile__avatar profile__avatar--fallback">
            {(profile.displayName ?? '?').slice(0, 1).toUpperCase()}
          </div>
        )}

        <div className="profile__identity">
          <p className="profile__name">{profile.displayName ?? 'Без имени'}</p>
          {profile.username ? <p className="profile__username">@{profile.username}</p> : null}
        </div>
      </div>

      <div className="profile__stats">
        <div className="stat">
          <p className="stat__value">{profile.ordersCount}</p>
          <p className="stat__label">Заказов</p>
        </div>
        <div className="stat">
          <p className="stat__value">
            <StarIcon size={15} /> {profile.starBalance}
          </p>
          <p className="stat__label">Баланс</p>
        </div>
        <div className="stat">
          <p className="stat__value">{new Date(profile.createdAt).toLocaleDateString('ru-RU')}</p>
          <p className="stat__label">С нами с</p>
        </div>
      </div>

      {SUPPORT_URL || TERMS_URL ? (
        <section className="profile__section">
          <h2 className="profile__section-title">Поддержка</h2>
          {SUPPORT_URL ? (
            <button type="button" className="row" onClick={() => openTelegram(SUPPORT_URL)}>
              <span>Написать в поддержку</span>
              <span className="row__chevron">›</span>
            </button>
          ) : null}
          {TERMS_URL ? (
            <button type="button" className="row" onClick={() => webApp?.openLink(TERMS_URL)}>
              <span>Условия и возвраты</span>
              <span className="row__chevron">›</span>
            </button>
          ) : null}
        </section>
      ) : null}

      {/* Диагностика: в вебвью нет DevTools, и версия клиента объясняет
          половину «необъяснимых» багов с методами Mini App. */}
      <footer className="profile__footer">
        {isInsideTelegram()
          ? `Telegram ${webApp?.platform} · WebApp ${webApp?.version}`
          : 'Открыто вне Telegram (режим разработки)'}
      </footer>
    </div>
  );
}
